import * as React from "react";
import ReadService from "../../service/read";
import PopDetail from "../popdetail";
import AddDocumentPane from "../add/add_document";
import Wait from "../wait";
import DeleteService from "../../service/v1/delete";
import {ProjectsService} from "../../service/v1/projects";

export default class DocumentPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            docs: [],
            attached_documents: [],
            required_documents: [],
            current_file: {},
            current_doc: <div/>,
            isApproved: sessionStorage.getItem(`lup_report_approved_${this.props.project.id}`) === 'true'
        }

        this.loadData = this.loadData.bind(this)
        this.showDoc = this.showDoc.bind(this)
        this.deleteDoc = this.deleteDoc.bind(this)
        this.downloadFile = this.downloadFile.bind(this)
        this.handleApprove = this.handleApprove.bind(this)
    }

    componentDidMount() {
        this.loadData()
        // Check if the document has been approved
        const isApproved = sessionStorage.getItem(`lup_report_approved_${this.props.project.id}`) === 'true'
        if (isApproved !== this.state.isApproved) {
            this.setState({ isApproved })
        }
    }

    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const container = {
            width: '100%',
            minHeight: '100vh',
            background: '#f6f8fa',
            fontFamily,
            padding: '0 24px 24px 24px'
        };
        const header = {
            padding: '18px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            fontFamily,
            borderBottom: '1px solid #e0e7ef',
            marginBottom: '24px'
        };
        const approveBtn = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 8,
            padding: '10px 28px',
            fontWeight: 700,
            fontSize: 14,
            cursor: sessionStorage.getItem('user_groups') === 'ADMIN' ? 'pointer' : 'not-allowed',
            opacity: sessionStorage.getItem('user_groups') === 'ADMIN' ? 1 : 0.5,
            marginLeft: 16,
            fontFamily
        };
        const mainRow = {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 24,
            fontFamily
        };
        const leftCol = {
            flex: '0 0 340px',
            display: 'flex',
            flexDirection: 'column',
            gap: 18
        };
        const docCard = {
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '18px 16px',
        };
        const docHeader = {
            fontSize: 16,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: 12,
            fontFamily
        };
        const docList = {
            margin: 0,
            padding: 0,
            listStyle: 'none'
        };
        const docItem = {
            color: '#333',
            width: '100%',
            padding: '10px 12px',
            borderRadius: 8,
            marginBottom: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            fontFamily,
            fontWeight: 500,
            fontSize: 14,
            border: '1px solid transparent',
            transition: 'background 0.2s, border-color 0.2s',
        };
        const addIconStyle = {
            color: '#00984b',
            fontSize: 16,
            transition: 'transform 0.2s'
        };
        const trashIconStyle = {
            color: '#e74c3c',
            fontSize: 14,
            transition: 'transform 0.2s'
        };
        const rightCol = {
            flex: '1 1 auto',
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '16px',
            minHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        };
        const docViewerPlaceholder = {
            textAlign: 'center',
            color: '#aaa',
            fontSize: 16,
            fontWeight: 500
        };

        const docToDisplay = this.state.current_file.path ? (
            <object>
                <embed id="pdfID" type="text/html" width="100%" height="100%" src={this.state.current_file.path}/>
            </object>
        ) : (
            <div style={docViewerPlaceholder}>
                <span className="fa fa-file-text-o" style={{fontSize: 48, marginBottom: 16}}/>
                <p>Select a document to view</p>
            </div>
        );

        return (
            <div style={container}>
                <div style={header}>
                    <span><span className={'fa fa-paperclip'} style={{marginRight: 12}}/>Documents</span>
                    {(sessionStorage.getItem('user_groups') === 'ADMIN' || sessionStorage.getItem('user_groups') === 'COORDINATOR') && this.props.taskId === 24 && 
                        <button 
                            style={approveBtn}
                            onClick={sessionStorage.getItem('user_groups') === 'ADMIN' ? this.handleApprove : undefined}
                            disabled={sessionStorage.getItem('user_groups') !== 'ADMIN'}
                        >
                            <span className={'fa-sharp fa-solid fa-check'} style={{marginRight: 8}}/>{this.state.isApproved ? 'Approved' : 'Approve LUP Report'}
                        </button>
                    }
                </div>
                <div style={mainRow}>
                    <div style={leftCol}>
                        <div style={docCard}>
                            <div style={docHeader}><span className={'fa fa-paperclip'} style={{marginRight: 8}}/>Required Documents</div>
                            <ul style={docList}>
                                {this.state.required_documents.map((d, i) => (
                                    <li key={i} style={docItem} title={d.description}
                                        onClick={()=>PopDetail.show(d.name,<AddDocumentPane document={d} screen_code={this.props.screen_code} taskId={this.props.taskId} project={this.props.project} loadData={this.loadData} key={new Date().getMilliseconds()}/>,40)}
                                        onMouseOver={e => e.currentTarget.style.background = '#f7f9fa'}
                                        onMouseOut={e => e.currentTarget.style.background = 'transparent'}
                                    >
                                        <span><span className={'fa fa-times'} style={{marginRight: 8, color: '#e74c3c'}}/>{d.name}</span>
                                        <span className={'fa fa-plus'} style={addIconStyle}/>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div style={docCard}>
                            <div style={docHeader}><span className={'fa fa-paperclip'} style={{marginRight: 8}}/>Attached Documents</div>
                            <ul style={docList}>
                                {this.state.attached_documents.map((d, i) => (
                                    <li key={i} style={{...docItem, color: 'darkcyan'}} title={d.description}
                                        onMouseOver={e => e.currentTarget.style.background = '#f7f9fa'}
                                        onMouseOut={e => e.currentTarget.style.background = 'transparent'}
                                    >
                                        <span onClick={() => this.showDoc(d)} style={{flex: 1, cursor: 'pointer'}}>
                                            <span className={'fa fa-check'} style={{marginRight: 8, color: '#27ae60'}}/>
                                        {d.name}
                                    </span>
                                    {sessionStorage.getItem('user_groups') === 'COORDINATOR' && (
                                            <span className={'fa fa-trash'} onClick={() => this.deleteDoc(d)} style={trashIconStyle}/>
                                    )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div style={rightCol}>
                        <div style={{width: '100%', height: '100%'}}>{docToDisplay}</div>
                </div>
                </div>
            </div>
        )
    }

    loadData() {

        try {
            Wait.show('Fetching Documents....')
            ProjectsService.fetchRequiredDocuments(this.props.project.id,this.props.taskId).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        attached_documents: r.data.attached_documents,
                        required_documents: r.data.required_documents
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    deleteDoc(d) {

        try {
            Wait.show('Removing Document')
            DeleteService.removeDocument(d.id).then(r => {
                Wait.dismiss()
                this.loadData()
            })
        } catch (e) {
            console.log(e)
        }
    }

    showDoc(d) {
        let path = d.path
        this.setState({
            current_file: d,
        })
    }

    downloadFile() {
        //window.open(API.base_url.split('/api')[0] + '' + this.state.current_file.doc_path)
    }

    handleApprove() {
        if (sessionStorage.getItem('user_groups') === 'ADMIN') {
            sessionStorage.setItem(`lup_report_approved_${this.props.project.id}`, 'true');
            this.setState({ isApproved: true });
            this.loadData(0);
        }
    }
}

    
